export default __webpack_public_path__ + "static/media/low-premium.c04bb1f4.svg";